/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const containerMarginCss = css({
  margin: '64px 0',
  [MediaQueries.md]: {
    margin: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    margin: '160px 0',
  },
});

export const headlineColCss = css({
  marginBottom: 24,
  [MediaQueries.md]: {
    marginBottom: 16,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 24,
  },
});

export const contentBlockCss = css({
  [MediaQueries.md]: {
    paddingLeft: 40,
  },
});

export const upperHeadlineCss = css(typography.effra18, {
  color: colorsPalette.grey80,
  marginTop: 17,
  marginBottom: 8,
  [MediaQueries.lgAndUp]: {
    marginTop: 40,
  },
});

export const headlineCss = css(typography.effra48, {
  color: colorsPalette.grey,
  fontWeight: fontWeights.medium,
  position: 'relative',
  display: 'inline',
});

export const bodyTextCss = css(typography.effra18, {
  color: colorsPalette.grey80,
  marginBottom: 40,
});

export const featuresColumnCss = css({
  width: '100%',
});

export const featuresListCss = css({
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%',
  justifyContent: 'space-between',
});

export const iconContainerCss = css({
  display: 'inline-block',
  height: 18,
  margin: '3px 13px 0',
  minWidth: 18,
  verticalAlign: 'middle',
  width: 18,
});

export const amenityItemCss = css(typography.effra16, {
  alignItems: 'flex-start',
  display: 'flex',
  marginBottom: 24,
  paddingRight: 10,
  verticalAlign: 'middle',
  width: '100%',
  [MediaQueries.lgAndUp]: {
    width: '50%',
  },
});

export const previewImageStyleIcon = css({
  width: '100%',
  height: '100%',
  img: {
    width: '100%',
    height: '100%',
  },
});

export const amenityNameCss = css({
  display: 'inline-block',
});

export const imageRightCss = css({
  display: 'flex',
  order: 2,
});

export const spacerCss = css({
  [MediaQueries.lgAndUp]: {
    paddingBottom: 32,
    borderBottom: `1px solid ${colorsPalette.grey10}`,
  },
  [MediaQueries.xl]: {
    paddingBottom: 72,
  },
});
